
// Ticketing System Pages 
import Login from "main_views/login";
import ResetPassword from "main_views/login/resetPassword";
import Home from "main_views/home";
import Tasks from "main_views/Tasks"
import History from "main_views/history";
import Setting from "main_views/settings";
import Forms from "main_views/form";
import Staff from "main_views/staff";
import CompletedTickets from "main_views/tickets/complete";
import RecjectedTickets from "main_views/tickets/rejected";
import ApprovedTickets from "main_views/tickets/approved";
import AllTickets from "main_views/allSystemTickets";
import Search from "main_views/search"

import i18n from 'utils/translation/i18n'

const routes = [
  {
    path: "/login",
    name: "Login",
    icon: "nc-icon nc-bank",
    component: Login,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/reset-pass",
    name: "reset-pass",
    icon: "nc-icon nc-bank",
    component: ResetPassword,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/home",
    name: 'home',
    icon: "nc-icon nc-bank",
    component: Home,
    layout: "/admin",
  },
  {
    path: "/tasks",
    name: 'my_tasks',
    icon: "nc-icon nc-paper",
    component: Tasks,
    layout: "/admin",
  },
  {
    path: "/history",
    name: 'my_history',
    icon: "nc-icon nc-refresh-69",
    component: History,
    layout: "/admin",
  },
  {
    //path: "/tickets",
    collapse: true,
    name: 'requests',
    icon: "nc-icon nc-book-bookmark",
    //component: Tickets,
    //layout: "/admin",
    state: "requestCollapse",
    views: [
      {
        path: "/completed",
        name: 'complete',
        mini: "C",
        component: CompletedTickets,
        layout: "/admin",
      },
      {
        path: "/rejected",
        name: 'rejected',
        mini: "R",
        component: RecjectedTickets,
        layout: "/admin",
      },
      {
        path: "/approved",
        name: 'approved',
        mini: "A",
        component: ApprovedTickets,
        layout: "/admin",
      }]
  },
  {
    path: "/all-tickets",
    name: 'all_tickets',
    icon: "nc-icon nc-single-copy-04",
    component: AllTickets,
    layout: "/admin",
  },
  {
    path: "/search",
    name: 'search',
    icon: "nc-icon nc-zoom-split",
    component: Search,
    layout: "/admin",
  },
  {
    path: "/form-builder",
    name: 'form_builder',
    icon: "nc-icon nc-ruler-pencil",
    component: Forms,
    layout: "/admin",
  },
  {
    path: "/staff",
    name: 'staff',
    icon: "nc-icon nc-single-02",
    component: Staff,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: 'setting',
    icon: "nc-icon nc-settings-gear-65",
    component: Setting,
    layout: "/admin",
  },
];

export default routes;
